import React from 'react'
import { TRADE_TYPE } from '@components/ExperienceShop/constant'
import { hashHistory } from 'react-router'
import { EXPERIENCE_SHOP_COOP_MANAGE } from '@constant'
import { getMoney } from '@hlj/hlj-utils'

export default [
  {
    title: '时间',
    dataIndex: 'tradeTime'
  },
  {
    title: '流水号',
    dataIndex: 'tradeNo'
  },
  {
    title: '合作订单号',
    dataIndex: ['cooperateOrder', 'orderNo'],
    render: (o, { cooperateOrder }) => {
      cooperateOrder = cooperateOrder || {}
      return (
        <a
          onClick={() => {
            hashHistory.push(
              `${EXPERIENCE_SHOP_COOP_MANAGE}/detail/${cooperateOrder.id}`
            )
          }}
        >
          {cooperateOrder.orderNo}
        </a>
      )
    }
  },
  {
    title: '订单金额',
    dataIndex: ['cooperateOrder', 'totalMoney'],
    render: (o, { cooperateOrder }) => {
      cooperateOrder = cooperateOrder || {}
      return <div>{cooperateOrder.totalMoney}</div>
    }
  },
  {
    title: '交易类型',
    dataIndex: 'type',
    render: (o, { type }) => {
      return <div>{TRADE_TYPE[String(type)]}</div>
    }
  },
  {
    title: '收支金额（元）',
    dataIndex: 'changeMoney',
    render: changeMoney => {
      return getMoney(changeMoney)
    }
  },
  {
    title: '服务费账户余额（元）',
    dataIndex: 'brokerageBalance',
    render: brokerageBalance => {
      return getMoney(brokerageBalance)
    }
  }
]
